import React, { Component } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import styled from 'styled-components'
import './Styles'

import Background from './Components/Background'
import Main from './Components/Main'
import Feed from './Components/Feed'
import Audio from './Components/Audio'

const basename = "/webdrop/"

class App extends Component {
  render() {
    return (
    <Router basename={basename}>
      <Layout className="App">
        <Background />
        <Audio />
        <Switch>
          <Route exact path='/' component={Main} />
          <Route path='/feed/:username' component={Feed} />
        </Switch>
      </Layout>
    </Router>
    )
  }
}

const Layout = styled.div`
  position: relative;
`

export default App



// WEBPACK FOOTER //
// ./src/App.js